import {
  Box,
  Container,
  FormControl,
  Link,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import Title from "../../components/Pages/Title";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import AssignmentIcon from "@mui/icons-material/Assignment";
import React, { useEffect, useState } from "react";
import Pagination from "../../components/Pagination";
import * as Api from "../../openApi";
import { Account } from "../../openApi/api";
import { useUpcxChain } from "../../hook/useUpcxChain";
import { AccountsService } from "../../backend";

const Accounts = () => {
  const { selectedShard } = useUpcxChain();

  const [limit, setLimit] = useState(25);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);

  const [accounts, setAccounts] = useState<Account[]>([]);

  const handleChange = (event: SelectChangeEvent) => {
    setLimit(parseInt(event.target.value));
    setPage(0);
  };

  const getUserList = async () => {
    const result = await AccountsService.getAccounts(limit, page);
    setTotal(result?.total ?? 0);
    setAccounts(result?.accounts ?? []);
  };

  useEffect(() => {
    if (!selectedShard) {
      return;
    }

    getUserList();
    // eslint-disable-next-line
  }, [page, limit, selectedShard]);

  return (
    <>
      <Title title="Top Accounts by UPC Balance " smallTitle="" />

      <Container className="container-xxl pt-5 pb-12">
        <Box className="card">
          <Box className="card-body">
            <Box className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <Box>
                <span className="text-dark gap-1">
                  <Link>{total.toLocaleString()} accounts </Link>found
                </span>
                <Box className="d-block text-muted small">
                  (Showing the last 10,000 top accounts only)
                </Box>
              </Box>
              <Box className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                <Pagination
                  limit={limit}
                  page={page}
                  setPage={setPage}
                  total={total}
                />
              </Box>
            </Box>
          </Box>

          <TableContainer component={Paper} className="box-shadow-0">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">#</TableCell>
                  <TableCell align="left">Address</TableCell>
                  <TableCell align="left">Name Tag</TableCell>
                  <TableCell align="left">Balance</TableCell>
                  <TableCell align="left">Percentage</TableCell>
                  <TableCell align="left">Txn Count</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {accounts.map((data, index) => (
                  <TableRow key={`account_${index}`}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <Box className="d-flex d-flex align-items-center gap-1">
                        <Box className="d-flex align-items-center gap-1 border px-1 border-0">
                          <Tooltip
                            title="Public Tag: Fee Recipient: 0xe68...127 (0xe688b84b23f322a994a53dbf8e15fa82cdb71127)"
                            placement="top"
                          >
                            <Link
                              href={`/address/${data.accountName}`}
                              className=""
                              data-bs-toggle="tooltip"
                              data-bs-trigger="hover"
                              data-bs-html="true"
                              data-bs-title="0x1dde41f92d3f7a46ce6f6de24ab3a94a45a3d708"
                            >
                              {data.accountName}
                            </Link>
                          </Tooltip>
                        </Box>

                        <Tooltip title="Copy Address" placement="top">
                          <Link className="js-clipboard link-secondary ">
                            <ContentCopyIcon
                              className="text-icon"
                              onClick={() =>
                                navigator.clipboard.writeText(data.accountName)
                              }
                            />
                          </Link>
                        </Tooltip>
                      </Box>
                    </TableCell>
                    <TableCell>UPCX Account</TableCell>
                    <TableCell>{data.balance.toLocaleString()} UPC</TableCell>
                    <TableCell>
                      {(data.balance / 10000000).toFixed(10)}%
                    </TableCell>
                    <TableCell>0</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box className="card-body">
            <Box className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <Box
                id="ContentPlaceHolder1_pageRecords"
                className="d-flex align-items-center gap-2 text-nowrap text-muted"
              >
                Show:
                <FormControl sx={{ m: 1, minWidth: 70 }}>
                  <Select
                    value={limit.toString()}
                    onChange={handleChange}
                    displayEmpty
                    size="small"
                    sx={{
                      fontSize: "12px",
                    }}
                  >
                    <MenuItem
                      value={10}
                      sx={{
                        fontSize: "12px;",
                      }}
                    >
                      10
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "12px;",
                      }}
                      value={25}
                    >
                      25
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "12px;",
                      }}
                      value={50}
                    >
                      50
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "12px;",
                      }}
                      value={100}
                    >
                      100
                    </MenuItem>
                  </Select>
                </FormControl>
                Records
              </Box>
              <Box className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                <Pagination
                  limit={limit}
                  page={page}
                  setPage={setPage}
                  total={total}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default Accounts;
